import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Assuming you're using React Router
import { all_routes } from "../../../feature-module/router/all_routes";

const Loader = () => {
  const route = all_routes
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    // Only show loader for login/authentication routes
    const isAuthRoute = 
      location.pathname === '/login' || 
      location.pathname === '/register' ||
      location.pathname === '/forgot-password' ||
      location.pathname === '/reset-password' ||
      location.pathname === '/email-verification' ||
      location.pathname === '/two-step-verification'

    if (isAuthRoute) {

      // Show the loader when navigating to a new route
      setShowLoader(true);
      const timeoutId = setTimeout(() => {
        setShowLoader(false);
      }, 500);

      return () => {
        clearTimeout(timeoutId);
      };
    } else {
      setShowLoader(false);
    }
  }, [location.pathname, route.dealsDashboard, route.leadsDashboard, route.projectDashboard]);

  return (
    <>
      {showLoader && <Preloader />}
      <div>
        {/* Your other content goes here */}
      </div>
    </>
  );
};

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Loader;
